// extracted by mini-css-extract-plugin
export default {"pwInfo":"PublicWelfareCert_pwInfo__DZ0Nc","certBox":"PublicWelfareCert_certBox__veEV+","text":"PublicWelfareCert_text__IbJc7"};